export default "__VITE_ASSET__C8jsGNDs__"